import React, { useEffect, createElement } from 'react';
import { Landing } from './pages/Landing';
import { initPixel } from './lib/pixel';
function injectResourceHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  if (!head) return;
  const hints: Array<{
    rel: string;
    href: string;
    as?: string;
    crossOrigin?: string;
    type?: string;
  }> = [
  // Preconnect — establish TLS handshake early to critical origins
  {
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous'
  }, {
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossOrigin: 'anonymous'
  },
  // DNS-prefetch — non-critical 3rd parties
  {
    rel: 'dns-prefetch',
    href: 'https://connect.facebook.net'
  }, {
    rel: 'dns-prefetch',
    href: 'https://www.mercadopago.com.ar'
  },
  // Preload LCP candidates — bundle hero image + first carousel slide
  {
    rel: 'preload',
    as: 'image',
    href: 'https://cdn.magicpatterns.com/uploads/2Uy1ouDYEkv5CsNPZdVTGV/BUNDLE_HORIZONTAL.png'
  }, {
    rel: 'preload',
    as: 'image',
    href: 'https://cdn.magicpatterns.com/uploads/cVxZaj5iHimcpWQSCzfF4h/CARRUSEL_FOTO_1.png'
  }];
  hints.forEach(h => {
    // Skip if an identical link already exists
    const existing = head.querySelector(`link[rel="${h.rel}"][href="${h.href}"]`);
    if (existing) return;
    const link = document.createElement('link');
    link.rel = h.rel;
    link.href = h.href;
    if (h.as) link.setAttribute('as', h.as);
    if (h.crossOrigin) link.setAttribute('crossorigin', h.crossOrigin);
    if (h.type) link.type = h.type;
    head.appendChild(link);
  });
  // theme-color meta — improves perceived first paint on mobile chrome
  if (!head.querySelector('meta[name="theme-color"]')) {
    const m = document.createElement('meta');
    m.name = 'theme-color';
    m.content = '#2F4538';
    head.appendChild(m);
  }
}
export function App() {
  useEffect(() => {
    // Inject resource hints synchronously (cheap DOM ops)
    injectResourceHints();
    // Pixel runs in idle / next tick — never blocks paint
    const idle = (window as any).requestIdleCallback || ((cb: () => void) => setTimeout(cb, 200));
    idle(() => initPixel());
  }, []);
  return <Landing data-id="element-0" />;
}